import React from 'react';

function Header() {
	return (
		<header className='header'>
			<h1 className='main-title'>Learn to code by watching others</h1>
			<p className='intro'>
				See how experienced developers solve problems in real-time. Watching scripted tutorials is
				great, but understanding how developers think is invaluable.
			</p>
		</header>
	);
}

export default Header;
